import { BreakpointObserver } from "@angular/cdk/layout";
import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { ConfirmationService } from "primeng/api";
import { AppService } from "src/app/core/services/app.service";
import { FocuslinkService } from "src/app/core/services/focuslink.service";
import { GoogleAnalyticsService } from "src/app/core/services/google-analytics.service";
import { LocalDataStoreService } from "src/app/core/services/local-data-store.service";
import { EGiftVenue } from "src/app/shared/models/eGift/EGiftVenue.model";

@Component({
	selector: "app-gift-balance-check",
	templateUrl: "./gift-balance-check.component.html",
	styleUrls: ["../gift.style.scss"],
})
export class GiftBalanceCheckComponent implements OnInit {
	cardBalance: number;
	giftCardNumber: string;
	eGiftVenue: EGiftVenue;

	transactionKey: string;
	venueKey: number;

	constructor(
		public app: AppService,
		public breakpointObserver: BreakpointObserver,
		private confirmationService: ConfirmationService,
		private googleAnalytics: GoogleAnalyticsService,
		private focuslink: FocuslinkService,
		private route: ActivatedRoute,
		private storage: LocalDataStoreService,
		private titleService: Title
	) {}

	ngOnInit(): void {
		this.titleService.setTitle("Check gift card balance.");
		this.app.loading(true);
		this.venueKey = +this.route.snapshot.paramMap.get("venueKey");
		let accountId = this.route.snapshot.queryParamMap.get("aid");
		if (accountId === "undefined") {
			accountId = undefined;
		}
		console.log(`set vk = ${this.venueKey}`);
		this.giftCardNumber = accountId || undefined;
		this.load();
	}

	async load() {
		try {
			this.eGiftVenue = await this.focuslink.eGiftVenueGet(this.venueKey);
		} catch (error) {}

		this.app.loading(false);
	}

	async balanceCheck() {
		const resp = await this.focuslink.getGiftBalance(this.venueKey, this.giftCardNumber);
		this.cardBalance = resp.balance;
		this.transactionKey = resp.transactionKey || undefined;
	}
}
